// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5278":"f18769db","6205":"f18769db"}[chunkId] + ".chunk.css";
};